import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const STORAGE_KEY = 'cookies-aceptadas';

export default function CookieBanner() {
    const [visible, setVisible]     = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        // Mostrar solo si el usuario no aceptó todavía
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    const aceptar = () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        setVisible(false);
        setModalOpen(false);
    };

    if (!visible) return null;

    return (
        <>
            {/* ── Banner fijo abajo ─────────────────────────────── */}
            <div className="cookieBanner" role="dialog" aria-live="polite">
                <div className="cookieBannerTexto">
                    <span className="cookieBannerIcon">🍪</span>
                    <p>
                        Usamos cookies para mejorar tu experiencia en el sitio.
                        Al continuar navegando, aceptás su uso.
                    </p>
                </div>
                <div className="cookieBannerBtns">
                    <button
                        className="cookieBannerBtnInfo"
                        onClick={() => setModalOpen(true)}
                    >
                        Más información
                    </button>
                    <button
                        className="cookieBannerBtnAceptar"
                        onClick={aceptar}
                    >
                        Aceptar
                    </button>
                </div>
            </div>

            {/* ── Modal de política ────────────────────────────── */}
            {modalOpen && (
                <div
                    className="cookieModalOverlay"
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        className="cookieModal"
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            className="cookieModalCerrar"
                            onClick={() => setModalOpen(false)}
                            aria-label="Cerrar"
                        >
                            ✕
                        </button>

                        <h2>Política de cookies</h2>

                        <p>
                            Las cookies son pequeños archivos de texto que los sitios web guardan
                            en tu dispositivo cuando los visitás. Nos permiten recordar tus
                            preferencias y mejorar tu experiencia de navegación.
                        </p>

                        <h3>¿Qué cookies usamos?</h3>
                        <ul>
                            <li>
                                <strong>Cookies esenciales:</strong> necesarias para que el sitio
                                funcione correctamente (sesión, carrito de compras).
                            </li>
                            <li>
                                <strong>Cookies de preferencias:</strong> recuerdan tu idioma y
                                configuración para futuras visitas.
                            </li>
                            <li>
                                <strong>Cookies analíticas:</strong> nos ayudan a entender cómo
                                usás el sitio para mejorarlo continuamente.
                            </li>
                        </ul>

                        <p>
                            Podés rechazar las cookies no esenciales o eliminarlas desde la
                            configuración de tu navegador en cualquier momento.
                        </p>

                        <button
                            className="cookieBannerBtnAceptar cookieModalBtnAceptar"
                            onClick={aceptar}
                        >
                            Entendido, aceptar
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
